import general from './general.json';
import auth from './auth.json';
import forms from './forms.json';
import dashboard from './dashboard.json';
import views from './views.json';
import permissions from './permissions';
import stock from "./stock.json";
import notifications from './notifications.json';
import toasts from './toasts.json';
import therapy from './therapy.json';
import location from './location.json';
import order from './order.json';
import invoice from './invoice.json';
import barcode from './barcode.json';
import tours from './tours.json';
import status from './status.json';
import holiday from './holiday.json';
import nitrogen from './nitrogen.json';
import publicForms from './public-forms.json';
import validation from './validation';

const messages = {
    ...general,
    ...auth,
    ...forms,
    ...dashboard,
    ...views,
    ...permissions,
    ...stock,
    ...notifications,
    ...toasts,
    ...therapy,
    ...invoice,
    ...location,
    ...order,
    ...barcode,
    ...tours,
    ...status,
    ...holiday,
    ...nitrogen,
    ...publicForms,
    validationErrors: validation,
};

export default messages;
